import { useEffect } from "react";
import { ReactComponent as LogoPastejo } from "../../../assets/svg/logo/logoPastejo.svg";
import { StepByStepV2 } from "../../../components/OnboardingV2/StepByStep/Index";
import { useOnboarding } from "../../../hooks/useOnboarding";
import { ShapeFileV2 } from "../RegisterV2/ShapeFileV2";
import { CreateProfilesV2 } from "../RegisterV2/CreateProfilesV2/Index";
import { CreateAssortmentV2 } from "../RegisterV2/CreateAssortmentV2/Index";
import { CreateFarmsV2 } from "../RegisterV2/CreateFarmsV2/Index";
import { CreateAreasByFarmV2 } from "../RegisterV2/CreateAreasByFarmV2/Index";
import { CreateMicroAreasByFarmV2 } from "../RegisterV2/CreateMicroAreasByFarmV2/Index";
import { Summary } from "../RegisterV2/Summary/Index";
import { LanguageSelector } from "../../../components/LanguageSelector";
import "./styles.css";
import { useTranslation } from "react-i18next";


export function OnboardingV2() {
  const { t } = useTranslation();
  const { payload, screenComponent, screenNumber, subScreenNumber, userProgress } = useOnboarding();
  const farms = payload?.farms || [];

  useEffect(() => {
    const section = userProgress.find((item) => item.section === screenNumber);
    const screen = section?.screens?.[subScreenNumber];
    document.title = screen?.name ? `Pastejo | ${screen.name}` : `Pastejo | ${t("formCards.onboarding")}`;
  }, [screenNumber, subScreenNumber, userProgress, t]);

  return (
    <section className="onboarding-v2">
      <header className="onboarding-v2__header">
        <LogoPastejo />
      </header>

      <aside className="onboarding-v2__nav">
        <div className="onboarding-v2__nav-steps">
          <StepByStepV2
            title={t("formCards.onboarding")}
            stepNumber={1}
            subSteps={[
              { name: t("onboardingRemaining.profiles"), element: <CreateProfilesV2 /> },
              { name: "ShapeFile", element: <ShapeFileV2 /> },
              { name: t("onboardingRemaining.agriculture"), element: <CreateAssortmentV2 /> },
              { name: t("onboardingRemaining.farms"), element: <CreateFarmsV2 /> },
            ]}
          />
          {farms.map((farm, index) => (
            <StepByStepV2
              key={farm.uuid || index}
              title={`${t("onboardingRemaining.farm")} ${index + 1}`}
              subtitle={farm.name || `${t("onboardingRemaining.farm")} ${index + 1}`}
              stepNumber={index + 2}
              subSteps={[
                { name: t("onboardingRemaining.area"), element: <CreateAreasByFarmV2 farmId={farm.uuid} /> },
                { name: t("onboardingRemaining.paddock"), element: <CreateMicroAreasByFarmV2 farmId={farm.uuid} /> },
              ]}
            />
          ))}
          <StepByStepV2
            key="onboarding-v2-summary"
            title={t("onboardingRemaining.summary")}
            stepNumber={farms.length + 2}
            subSteps={[{ name: t("onboardingRemaining.summary"), element: <Summary /> }]}
            lastStepAsSummary
          />
        </div>
        <LanguageSelector className="onboarding-v2__language-selector" />
      </aside>

      <section className="onboarding-v2__content">{screenComponent}</section>
    </section>
  );
}
